<div class="cg-dialog">
  <h3 class="cg-dialog__header cg-dialog__header--modal">
    Remove Access for {{ data.user.firstName }} {{ data.user.lastName }}
  </h3>

  <ng-container *ngIf="(removeAccessView$ | async) === 'error'">
    <div class="cg-error-msg cg-margin-bottom-lg">
      <cigna-icon type="exclamation-circle"></cigna-icon>
      <span data-spa-service-error
        >We’re sorry, the remove access submission was not successful. please
        try again later. If you still have trouble, call Cigna Customer Support
        at 1.855.221.0273. We’re available 24 hours a day, 365 days a
        year.</span
      >
    </div>
  </ng-container>

  <ng-container
    *ngIf="
      (removeAccessView$ | async) === 'edit' ||
      (removeAccessView$ | async) === 'error'
    "
  >
    <p class="cg-margin-bottom-lg">Select the TIN(s) you want to remove</p>

    <div class="cg-contrast-block-on-light">
      <cigna-select-tins-group
        [allTins]="data.user.tins"
        [columns]="3"
        (selectionsChange)="updateSelections($event)"
      >
      </cigna-select-tins-group>
    </div>

    <div>
      <p class="cg-margin-bottom-sm">
        Are you sure you want to remove this users access?
      </p>
    </div>

    <div class="cg-button-group cg-margin-top-lg">
      <button
        [disabled]="selectedTins.length === 0 || (impersonator$ | async)"
        data-test="cg-remove-access-btn"
        cignaButton="primary"
        (click)="onRemove()"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Remove Access',
          'ac-WC005-Remove Access'
        ]"
      >
        Remove Access
      </button>
      <button cignaButton="secondary" (click)="onClose()">Cancel</button>
    </div>
  </ng-container>

  <ng-container *ngIf="(removeAccessView$ | async) === 'loading'">
    <div class="cg-media">
      <div class="cg-media__img">
        <div class="cg-spinner cg-spinner-small"></div>
      </div>
      <div class="cg-media__bd cg-margin-top-xs cg-margin-left-sm">
        Removing access...
      </div>
    </div>
    <div class="cg-button-group cg-margin-top-lg">
      <button cignaButton="secondary" (click)="onClose()">Cancel</button>
    </div>
  </ng-container>

  <ng-container *ngIf="(removeAccessView$ | async) === 'success'">
    <div class="cg-media">
      <div class="cg-media__img">
        <cigna-icon
          class="cg-icon-md cg-color-digital-green"
          type="check-circle"
        ></cigna-icon>
      </div>
      <div class="cg-media__bd cg-margin-top-sm">Access Removed</div>
    </div>
    <div class="cg-button-group cg-margin-top-lg">
      <button cignaButton="secondary" (click)="onClose()">Close</button>
    </div>
  </ng-container>
</div>
